if ($.ui && $.ui.selectmenu) {
  $.widget('app.selectmenu', $.ui.selectmenu, {
    _drawButton() {
      this._super();
      const selected = this.element.find('[selected]').length;
      const { placeholder } = this.options;
      if (!selected && placeholder) this.buttonItem.text(placeholder);
    },
  });
}

const uiSelect = (el, pos) => {
  const select = el;
  let position = pos;
  if (!position) {
    position = { my: 'left top', at: 'left bottom', collision: 'none' };
  }
  select.wrap('<div class="ui-select-container"></div>');
  let placeholder = false;
  if (!select.children('[selected]').length || select[0].options.selectedIndex === -1) {
    if (select.attr('data-placeholder') && select.data().placeholder.toString().length > 0) {
      placeholder = $(this).data('placeholder');
      select.val('').prop('value', '');
    }
  }
  select.selectmenu({
    width: '',
    appendTo: select.closest('.ui-select-container'),
    placeholder,
    position,
    select() {
      select.parent().find('.ui-selectmenu-button').removeClass('has-placeholder');
    },
    create() {
      select
        .css({
          display: 'block',
          opacity: 0,
          position: 'absolute',
        })
        .addClass('ui-select-loaded');
      if (placeholder) {
        select.parent().find('.ui-selectmenu-button').addClass('has-placeholder');
      }
      select.on('change', () => select.selectmenu('refresh'));
    },
    change() {
      select.trigger('change');
      select.parent().find('.ui-selectmenu-button').removeClass('has-placeholder');
    },
  });
};
export default uiSelect;
